import React from "react";
import {Redirect, Route} from "react-router-dom";

export default ({component: C, props: cProps, ...rest}) => {
  let redirect = "";
  let fullUrl = window.location.href;
  if (fullUrl.indexOf("redirect=") >= 0)
    redirect = fullUrl.substring(fullUrl.indexOf("redirect=") + 9);

  return (
    <Route
      {...rest}
      render={props =>
        !cProps.isAuthenticated
          ? <C {...props} {...cProps} />
          : <Redirect
            to={redirect === "" || redirect === null ? "/home" : redirect}
          />}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/UnauthenticatedRoute.js